import type { SVGProps } from "react";

/**
 * Logo oficial de WhatsApp en SVG. Hereda color con `currentColor` y respeta
 * `width`/`height` por className (`h-4 w-4`, etc.) igual que los iconos de
 * lucide-react para mantener API consistente.
 */
export function WhatsAppIcon({
  className,
  ...rest
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...rest}
    >
      <path d="M19.077 4.928A9.9 9.9 0 0 0 12.06 2.02c-5.46 0-9.91 4.45-9.913 9.91a9.9 9.9 0 0 0 1.323 4.957L2 22l5.254-1.378a9.9 9.9 0 0 0 4.802 1.225h.004c5.46 0 9.91-4.45 9.913-9.911a9.86 9.86 0 0 0-2.896-7.008m-7.018 15.245h-.003a8.23 8.23 0 0 1-4.192-1.149l-.301-.179-3.118.818.832-3.041-.196-.312a8.22 8.22 0 0 1-1.262-4.39c.002-4.539 3.696-8.234 8.243-8.234 2.2 0 4.27.858 5.825 2.415a8.18 8.18 0 0 1 2.412 5.826c-.002 4.539-3.696 8.234-8.24 8.234m4.521-6.166c-.247-.124-1.466-.724-1.693-.806s-.392-.124-.557.124-.64.806-.785.972-.289.187-.537.062c-.247-.124-1.045-.385-1.992-1.23-.736-.657-1.234-1.467-1.378-1.715-.144-.247-.015-.381.108-.504.111-.111.247-.289.371-.433.124-.144.165-.247.247-.412s.041-.31-.021-.433c-.062-.124-.557-1.343-.764-1.838-.2-.483-.404-.418-.557-.425a10 10 0 0 0-.475-.009.91.91 0 0 0-.661.31c-.227.247-.867.847-.867 2.066s.887 2.396 1.011 2.561c.124.165 1.747 2.668 4.232 3.74.591.255 1.052.408 1.412.522.594.189 1.134.162 1.561.099.476-.071 1.466-.6 1.673-1.179s.207-1.075.144-1.179c-.062-.103-.227-.165-.475-.289"/>
    </svg>
  );
}
